<template>
  <div
    class="video-box"
    :style="{
      height: itemData.height + 'px',
      background: `url(${itemData.backgroundUrl}?x-oss-process=image/resize,w_750/quality,q_80) top center / 100% 100%`,
      padding: `${itemData.padding.top}px ${itemData.padding.right}px ${itemData.padding.bottom}px ${itemData.padding.left}px`,
    }"
  >
    <!-- <video controls :src="itemData.videoUrl"></video> -->
    <div :id="id"></div>
  </div>
</template>

<script>
import Player from "xgplayer";
export default {
  props: {
    itemData: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      id: Math.round(Math.random() * 10000),
    };
  },
  mounted() {
    new Player({
      id: this.id,
      url: this.itemData.videoUrl, //'//sf1-cdn-tos.huoshanstatic.com/obj/media-fe/xgplayer_doc_video/mp4/xgplayer-demo-360p.mp4',
      fluid: true,
      autoplay: true,
      playsinline: true,
      loop: true,
    });
  },
};
</script>

<style lang="scss" scoped>
.video-box {
  #mse {
    width: 100%;
  }
}
</style>
